import { calculateTimeDifference } from '../../../../../shared/utils/time';
import { TIME_UNIT } from '../../../../../shared/utils/time/constants';
import { MESSAGE_EXPIRE_MINUTES } from '../constants';

/**
 * Returns whether the given message has expired
 * @param {{ sentAt: number }} message
 * @returns {boolean}
 */
export const isMessageExpired = (message) =>
    calculateTimeDifference(message.sentAt, TIME_UNIT.MINUTE) >= MESSAGE_EXPIRE_MINUTES;
